import React from 'react'

function CustomInputTextArea({
  label,
  value,
  onChange,
  onEnter = () => {},
  labelColor = '#14B0BF',
  marginTop = 20,
  disabled = false,
  showLabel = true,
  rows = 10,
}) {
  // Vars
  const styles = {
    container: {
      textAlign: 'left',
      marginTop,
    },
    label: {
      fontSize: '0.8rem',
      color: labelColor,
      display: 'block',
    },
    textarea: {
      width: '100%',
      outline: 'none',
      border: '1px solid #F1F1F1',
      borderRadius: 3,
      marginTop: 3,
      padding: 10,
      resize: 'none',
    },
  }

  // Render
  return (
    <div style={styles.container}>
      {showLabel ? (
        <label style={styles.label} htmlFor="myInput">
          {label} &nbsp; :
        </label>
      ) : null}
      <textarea
        rows={rows}
        disabled={disabled}
        style={styles.textarea}
        name="myInput"
        value={value}
        onChange={evt => onChange(evt.target.value)}
        onKeyPress={({ key }) => {
          if (key === 'Enter') {
            onEnter()
          }
        }}
      />
    </div>
  )
}

export default CustomInputTextArea
